// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__XwdrV","modalFooterButton":"ModalNotes_modalFooterButton__mOl-q"};